import { gql } from '~/src/generated/portal/gql';

const CURRENT_USER = gql(`
  query getCurrentUser {
    currentUser {
      id
      firstName
      lastName
      profileName
      company
      defaultPartnerId
      email
      fullStoryDisclosureRequired
      locationHeaders {
        countryCode
        countryName
      }
      termsOfService {
        accepted
        timestamp
      }
      partnerWorkstreams {
        partnerId
        workstreams
        partner {
          id
          name
          confluenceName
          languages
          workstreams
          countryCode
        }
      }
      userType
      isPortalAdmin
      selectedPartner {
        id
        name
        confluenceName
        languages
        workstreams
        partnerPreferences {
          hasBetaAccess
        }
      }
      isAccessManagementAdmin
      isPerksManagementAdmin
      userPermissions {
        persona {
          __typename
          ... on DisneyAdmin {
            disneyAdmin
            userType
            providerConfigAdmin
          }
          ... on PartnerUser {
            partnerPermissions {
              partnerId
              partnerAdmin
              componentPermissions {
                ... on WorkstreamPermission {
                  workstream
                  workstreamAdmin
                }
                ... on ADKSourceCodePermission {
                  sourceCodeAccess
                }
                ... on OnDeviceActivationPermission {
                  onDeviceActivationAccess
                }
                ... on ContentProviderAdditionalFieldsPermission {
                  contentProviderAdditionalFieldsAccess
                }
                ... on EntitlementPushBasedApiPermission {
                  entitlementPushBasedApiAccess
                }
                ... on RefundsAndChargebacksPushBasedApiPermission {
                  refundsAndChargebacksPushBasedApiAccess
                }
              }
            }
          }
          ... on DisneyUser {
            spacePermissions {
              ... on PartnerPermission {
                partnerId
                partnerAdmin
                componentPermissions {
                  ... on WorkstreamPermission {
                    workstream
                    workstreamAdmin
                  }
                  ... on ADKSourceCodePermission {
                    sourceCodeAccess
                  }
                  ... on OnDeviceActivationPermission {
                    onDeviceActivationAccess
                  }
                  ... on ContentProviderAdditionalFieldsPermission {
                    contentProviderAdditionalFieldsAccess
                  }
                  ... on EntitlementPushBasedApiPermission {
                    entitlementPushBasedApiAccess
                  }
                  ... on RefundsAndChargebacksPushBasedApiPermission {
                    refundsAndChargebacksPushBasedApiAccess
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);

export default CURRENT_USER;
